import { get } from 'lodash';
import { AxiosRequestConfig } from 'axios';
import { call, put, select } from 'redux-saga/effects';

import { startSendApiError, startSendApiRequest, startSendApiSuccess } from '../actions';

import { IAction } from '../../../interfaces/IAction';

import axiosInstance from '../axiosInstance';
import { getAuthToken } from '../../../containers/Auth/selectors';
import { logError } from '../../../utils/ErrorLogger';

interface ICreateApiRequestSagaParams {
  actionSuccess: any;
  actionError: any;
}

export function* sendApiRequest(request: AxiosRequestConfig, meta: any) {
  yield put(startSendApiRequest(request));

  try {
    const { data } = yield call(axiosInstance.request, request);

    yield put(startSendApiSuccess(data, meta));

    return {
      data,
      isError: false,
    };
  } catch (ex) {
    const data = {
      status: get(ex, ['response', 'status']),
      message: ex.message,
      errors: get(ex, ['response', 'data'], {}),
    };

    if (data.status >= 200) {
      logError(ex);
    }

    yield put(startSendApiError(data, meta));

    return {
      data,
      isError: true,
    };
  }
}

export const createApiRequestSaga = ({ actionSuccess, actionError }: ICreateApiRequestSagaParams) => {
  return function* wrappedApiRequestSaga({ payload, meta }: IAction) {
    const token = yield select(getAuthToken);

    if (token) {
      payload = { ...payload, headers: { ...payload.headers, Authorization: token } };
    }

    const { data, isError } = yield sendApiRequest(payload, meta);

    if (isError) {
      yield put(actionError(data));
    } else {
      yield put(actionSuccess(data));
    }
  };
};



// WEBPACK FOOTER //
// ./src/modules/api/saga/index.ts